import { FormProvider, useForm } from 'react-hook-form';
import styled from 'styled-components';

import LoadingView from '@/components/common/LoadingView';
import { useGetForeignCurrencyHistory } from '@/hooks/useGetForeignCurrencyHistory';
import FXReceiptItem from './FXReceiptItem';
import { FX_RECEIPT_HEADER } from '@/constants/fxReceipt';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { useEffect } from 'react';
import { setFilterSeletor } from '@/store/modules/refund';
import FXTableHeader from './FXTableHeader';

function FXReceiptListShort() {
  const { foreignCurrencies, isLoading, status, setStatus } =
    useGetForeignCurrencyHistory();
  const methods = useForm({
    defaultValues: {
      checked: false,
    },
  });
  const dispatch = useAppDispatch();

  useEffect(() => {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    const endDate = new Date();
    dispatch(
      setFilterSeletor({
        startDate,
        endDate,
      }),
    );
  }, []);

  return (
    <FormProvider {...methods}>
      {isLoading ? (
        <LoadingView height='80vh' />
      ) : (
        <>
          {foreignCurrencies && foreignCurrencies.content.length > 0 ? (
            <Table>
              <FXTableHeader
                titleList={FX_RECEIPT_HEADER}
                status={status}
                setStatus={setStatus}
              />
              <tbody>
                {foreignCurrencies.content
                  .slice(0, 5)
                  .map((foreignCurrency, index) => (
                    <FXReceiptItem
                      key={foreignCurrency.foreignCurrencyId}
                      foreignCurrency={foreignCurrency}
                      index={index}
                      currentPage={foreignCurrencies.number}
                    />
                  ))}
              </tbody>
            </Table>
          ) : (
            <PaymentNotContainer>수납 내역이 없습니다</PaymentNotContainer>
          )}
        </>
      )}
    </FormProvider>
  );
}

export default FXReceiptListShort;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
  background-color: ${(props) => props.theme.pointColors.white};
  border-radius: 16px;
  overflow: hidden;
`;

const PaymentNotContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 240px;
  flex: 1;
  background-color: #fff;
  border-radius: 16px;

  color: var(--Mono-50, #80848a);
  text-align: center;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;
